/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getQueryBuildingBedroomCount
 */

import { isBedroomsSelected } from '@zcode-ui/filters'
import { bedroomCountToBoolArray } from '@zcode/nr/es/shared/utils/filter'
import type {
  Building,
  Filters,
  ListableBuilding,
  PinBuilding,
  RawPinInventorySearch,
} from '@zcode/state-type'

export const getQueryBuildingBedroomCount = (
  entity: Building | ListableBuilding | PinBuilding<RawPinInventorySearch>,
  filters: Partial<Filters> | undefined
) => {
  if (isBedroomsSelected(filters)) {
    return filters.bedrooms
  }

  if (entity) {
    const minBedrooms = bedroomCountToBoolArray(entity.minBedrooms)
    return minBedrooms.reduce<[boolean, boolean, boolean, boolean, boolean, boolean]>(
      (bedrooms, val, i) => {
        bedrooms[i] =
          val ||
          (entity.minBedrooms != null &&
            entity.maxBedrooms != null &&
            entity.minBedrooms <= i &&
            i <= entity.maxBedrooms)
        return bedrooms
      },
      [false, false, false, false, false, false]
    )
  }

  return [false, false, false, false, false, false] as const
}
